require('./dist/js/nya-bs-select');

module.exports = 'nya.bootstrap.select';
